import Field from '../../Field';
import {
  type FieldContentsData,
  type IntegrationContent,
} from 'javascripts/shared-types';
import { type CardLayoutModelConstructorType } from '../../types';
import IntegrationLink from 'components/framework/models/IntegrationLink';

import asanaIcon from 'images/integrations/asana.svg';
import githubEnterpriseIcon from 'images/integrations/github_enterprise.svg';
import githubIcon from 'images/integrations/github.svg';
import jiraIcon from 'images/integrations/jira.svg';
import rallyIcon from 'images/integrations/rally.svg';
import salesforceIcon from 'images/integrations/salesforce.svg';
import tfsIcon from 'images/integrations/tfs.svg';
import trelloIcon from 'images/integrations/trello.svg';
import vstsIcon from 'images/integrations/vsts.svg';
import { type RecordLayout } from 'components/framework/models';
import { type IntegratedRecordInterface } from 'components/framework/models/generated/types';

const ICONS = {
  asana: asanaIcon,
  github_enterprise: githubEnterpriseIcon,
  github: githubIcon,
  jira: jiraIcon,
  rally: rallyIcon,
  salesforce: salesforceIcon,
  tfs: tfsIcon,
  trello: trelloIcon,
  vsts: vstsIcon,
};

export class Integrations extends Field {
  static availableForModel(
    modelClass: CardLayoutModelConstructorType,
    recordLayout: RecordLayout
  ): boolean {
    if (!window.currentAccount?.roadmapFlavor) return false;

    return super.availableForModel(modelClass, recordLayout);
  }

  static subqueriesForModel(
    modelClass: CardLayoutModelConstructorType
  ): Record<string, any> {
    return {
      integrationLinks: IntegrationLink.select('name', 'url').merge({
        integration: ['name', 'serviceName'],
      }),
    };
  }

  get title() {
    return 'Integrations';
  }

  exampleContents(): FieldContentsData {
    return {
      integrations: [{ name: 'Issue FWRJ-15', icon: jiraIcon, url: '#' }],
    };
  }

  contentsForRecord(record: IntegratedRecordInterface): FieldContentsData {
    if (!record.integrationLinks) return {};

    return {
      integrations: record.integrationLinks.map(
        (integrationLink): IntegrationContent => ({
          name: integrationLink.name,
          url: integrationLink.url,
          icon: ICONS[integrationLink.integration.serviceName],
          title: integrationLink.integration.title,
        })
      ),
    };
  }
}
